module.exports = __webpack_public_path__ + "img/about_2001.cc53d344.png";